import React from "react"
import styled from "styled-components"
import ScrollAnimation from "react-animate-on-scroll"
import { StyledTitle } from "../Title"
import StyledSmallTitle from "../styled/styledSmallTitle"
import Form from "../ContactForm"
import arrow from "../../images/icons/arrows/arrow-contact.svg"

const StyledSection = styled.section`
  padding: 52px 16px 0;
  overflow: hidden;
  background-color: #fffcfa;
  @media (min-width: 768px) {
    padding: 170px 16px 0;
    display: flex;
    flex-direction: column;
    max-width: 576px;
    margin: 0 auto;
    justify-content: center;
  }
  @media (min-width: 1024px) {
    max-width: 900px;
  }
  @media (min-width: 1200px) {
    max-width: 1200px;
    overflow: visible;
  }
`
const Description = styled.p`
  letter-spacing: 0.5px;
  color: #808080;
  @media (min-width: 1024px) {
    font-size: 20px;
    margin-top: 8px;
  }
`

const Element = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 42px;
  & p:first-child {
    font-family: "Made Bold", sans-serif;
    font-size: 32px;
    text-align: center;
    background-color: #fff;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 100%);
      background-image: url(${arrow});
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      width: 10px;
      height: 42px;
    }
  }
  & p:last-child {
    margin-left: 22px;
    font-size: 20px;
  }
`

const Box = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 1200px) {
    flex-direction: row;
  }
  @media (min-width: 1800px) {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
`

const Instruction = styled.div`
  box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #f9d6c1;
  margin-top: 32px;
  width: calc(100vw - 32px);
  transform: translateX(-16px);
  padding: 30px 16px;
  & ul ${Element}:last-child {
    margin-bottom: 0;
    & p:first-child {
      &::after {
        background-image: none;
      }
    }
  }
  @media (min-width: 768px) {
    border-radius: 8px;
    width: 100%;
  }
  @media (min-width: 1200px) {
    position: absolute;
    right: 0;
    padding: 30px;
    width: 435px;
    display: flex;
    align-items: center;
    border-radius: 8px 0 0 8px;
    transform: translateX(30px);
  }
  @media (min-width: 1800px) {
    position: static;
    transform: translateX(0);
    width: auto;
    border-radius: 8px;
  }
`

const ExtendStyledTitle = styled(StyledTitle)`
  @media (min-width: 768px) {
    padding-bottom: 0;
    margin-bottom: 16px;
    &::after {
      display: none;
    }
  }
`

const Contact = () => {
  return (
    <ScrollAnimation animateIn="fadeInUp" animateOnce>
      <StyledSection id="kontakt">
        <StyledSmallTitle>KONTAKT</StyledSmallTitle>
        <ExtendStyledTitle>
          <span>Projekt</span> z nis media?
        </ExtendStyledTitle>
        <Description>
          Wypełnij formularz, albo{" "}
          <a href="mailto:kontakt@nismedia.pl">wyślij nam e-mail</a>
        </Description>
        <Box>
          <Instruction>
            <ul>
              <Element>
                <p>1</p>
                <p>Wypełniasz formularz</p>
              </Element>
              <Element>
                <p>2</p>
                <p>Otrzymujesz 3 oferty</p>
              </Element>
              <Element>
                <p>3</p>
                <p>Wybierasz jedną z nich</p>
              </Element>
              <Element>
                <p>4</p>
                <p>Rozpoczynamy pracę</p>
              </Element>
              <Element>
                <p>5</p>
                <p>Akceptujesz projekt</p>
              </Element>
            </ul>
          </Instruction>
          <Form />
        </Box>
      </StyledSection>
    </ScrollAnimation>
  )
}

export default Contact
